import { Theme } from '@mui/material';

export const blockFillParent = {
  display: 'block',
  flex: '1 0 auto',
};

/**
 * Reusable style object to make an element flex and fill its parents empty space
 *
 * @returns CSSProperties to spread onto a class definition in `createStyles`
 */
export const flexFillParent = {
  display: 'flex',
  flex: '1 0',
};

export const useAddonStyles = (spacing: Theme['spacing']) => {
  return {
    addons: {
      marginLeft: 'auto',
      display: 'inline-flex',
      alignItems: 'center',
      verticalAlign: 'middle',
      '& > *': {
        marginLeft: spacing(),
      },
    },
  };
};
